import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { MenuService } from '../../../../services/menu.service';
import { DataIoService } from '../../../../services/data-io.service';
import { MenuNode } from '../../../../classes';
import { TextdisplayComponent } from '../../../helpers/textdisplay/textdisplay.component';
@Component({
	selector: 'screen-toast',
	templateUrl: './toast.component.html',
	styleUrls: ['./toast.component.scss']
})

export class ToastComponent implements OnInit,OnDestroy {

	@Input('debug') debug:boolean;
	enabled_buttons:Array<string>;
	
	title:string;
	eventSubscription:any;
	mode:string;
	dashIcon:string="";
	unit:string="";
	value:string="";
	constructor(private menuService: MenuService, private ioService: DataIoService) { 

	}

	ngOnInit() {
		this.mode = "default";
		if(this.menuService.hasParameter('setup')){
			this.mode = 'setup';
		}

		this.title = this.menuService.currentNode.getTitle();
		
		this.dashIcon = this.menuService.currentNode.getIcon();
		this.eventSubscription = this.ioService.inputs.events$.subscribe(
			(event)=>{this.eventHandler(event);}
			);
	}
	hasParameter(p:string):boolean{
		return this.menuService.hasParameter(p);
	}
	ngOnDestroy(){
			this.eventSubscription.unsubscribe();
	}
	getColor(idx){
		if(this.menuService.hasParameter('darkText'+idx.toString())){
			return 'grey';
		}
		return 'white';
	}
	eventHandler(event){

		switch(event){			
			case 'confirm':{
				let confirmation = this.menuService.currentNode.onConfirm({});
				let targetNode = this.menuService.currentNode.getTargetNode();
				if(targetNode){
					this.menuService.goto(targetNode,confirmation);
					return;
				}
				if(this.menuService.hasNextMenuItem()){
					this.menuService.selectNextMenuItem();
				}
				break;
			}
			case 'back':{
				if(this.menuService.getCurrentNode().hasBackTarget()){
					let backTarget = this.menuService.getCurrentNode().getBackTargetNode();
					this.menuService.goto(backTarget);
					return;
				}
				if(this.menuService.historyBack()){
					return;
				}
				
				if(this.menuService.hasPreviousMenuItem()){
					this.menuService.selectPreviousMenuItem();
				}
				break; 
			}
		}
	}
	getText(idx:number):string{
		return this.menuService.getText(idx);
	}

}
